import React, { useEffect, useState } from 'react'
import { cookiesKeyNames } from '@revbox/common-fe'
import { getPubAbbr, addBgOnIframe, getDaysDiff } from '@revbox/helpers-fe'
import { mixpanelInstance } from '../../mixpanel/instance'
import { useCookiesContext } from '../../contexts/CookiesContext'
import { Col, Row } from 'react-bootstrap'
import '../loader.css'
import { AuctionCampaignStatusCardModule } from '../../modules/AuctionCampaignStatusCard'

import { getCampaign } from '../../services/adv'
import { AuctionCreditBalanceCardModule } from '../../modules/AuctionCreditBalanceCard'
import { AuctionMonthlyBudgetCardModule } from '../../modules/AuctionMonthlyBudgetCard'
import { decrypt } from '../../helpers/crypto'

export default function PpcAuctionIframe() {
    const { getSkinMode, updateCookiesProperty } = useCookiesContext()
    const publisherIdByAbbr = getPubAbbr()

    const [iframe, setIframe] = useState(null)
    const [campaign, setCampaign] = useState(null)
    const [campaignId, setCampaignId] = useState(null)
    const [days_diff, setDaysDiff] = useState(null)
    const [campaignCategories, setCampaignCategories] = useState(null)
    const urlParams = new URLSearchParams(window.location.search)
    const [currentSkin, setCurrentSkin] = useState(getSkinMode())

    useEffect(() => {
        const campaignId = urlParams.get('campaignId')
        setCampaignId(campaignId)
        mixpanelInstance.track('PPC Auctions iFrame Loaded')
        addBgOnIframe();
        setIframe(1)
    }, [])

    useEffect(() => {
      if (iframe === 1) {
        const advId = urlParams.get('advId')
        if (!advId) {
          return
        }
        const decryptedAdvId = decrypt(advId)
        updateCookiesProperty(cookiesKeyNames.skinMode, "light", decryptedAdvId)
        setCurrentSkin("light")
        const element = document.querySelector('[data-skin]');
        if (element && element.hasAttribute('data-sidebar')) {
          element.setAttribute('data-skin', 'light')
          element.setAttribute('data-sidebar', 'light')
        }
      }
    
    }, [])
    
    const handleCampaignActivate = () => {
        window.location.href = '/adv/campaign/activate?campaignId=' + campaignId
    }

    useEffect(() => {
        if (!campaignId) {
            return
        }

        const getCampaignData = async () => {
            try {
                const res = await getCampaign(campaignId)

                if (!res || res.success === false) {
                    throw new Error('Campaign not found')
                }
                const campaignData = { ...res.data, ...res?.table }
                setCampaign(campaignData)
                const campaignCategories = campaignData?.related_categories_ids?.map(category => {
                    const label = campaignData?.columns
                        ?.find(c => c.name === 'related_categories_ids')
                        ?.options?.find(o => o.value === category)?.label
                    return label
                })

                const day2 = new Date().setMonth(new Date().getMonth() + 1)
                const days_diff = getDaysDiff(campaignData?.ppc_invoice_day, new Date(), new Date(day2).setDate(campaignData?.ppc_invoice_day))
                setDaysDiff(days_diff)
                setCampaignCategories(campaignCategories)
            } catch (error) {
                console.log('error', error)
            }
        }

        getCampaignData()
    }, [campaignId])

    if (iframe === 1) {
        return (
            <Row className="g-3 iframe-background htr-iframe-bg" style={{width: '100%', margin: '0 auto'}}>
                <Col md="12" xl="4">
                    <AuctionCampaignStatusCardModule 
                        publisher_id={publisherIdByAbbr}
                        campaign={campaign}
                        campaignCategories={campaignCategories}
                        currentSkin={currentSkin}
                        anyActiveSpecificBid={true}
                        anyActiveBrandingBid={true}
                        anyActiveClusterBid={true}
                        isIframe={true}
                    />
                </Col>
                <Col md="6" xl="4">
                    <AuctionCreditBalanceCardModule 
                        publisher_id={publisherIdByAbbr}
                        campaign={campaign}
                        isIframe={true}
                    />
                </Col>
                <Col md="6" xl="4">
                    <AuctionMonthlyBudgetCardModule 
                        publisher_id={publisherIdByAbbr}
                        campaign={campaign}
                        budgetLoading={false}
                        handleShowBottom={() => {}}
                        days_diff={days_diff}
                        handleCampaignActivate={handleCampaignActivate}
                        isIframe={true}
                    />
                </Col>
            </Row>
        )
    } else {
        return (
            <div>
                <span className="loader"></span>
            </div>
        )
    }
}
